import PropTypes from 'prop-types';

import { itemsWorkReport } from '../../../../utils/globalPropTypes';
import { AttachedFilesPermissions } from '../../../MonthlyServiceRequest/RequestDetailTypes';

import DailyWorkReportApproval from './DailyWorkReportApproval/DailyWorkReportApproval';

const HeaderTableApprovalPending = (props) => {
  const {
    fetchData,
    workReportsSecondLevel,
    selectedDate,
    selectedInput,
    showApproveButton,
    showEditButton,
    showImputationObjectButton,
    showRejectButton,
    permissions,
    showPPButton
  } = props;

  return (
    <>
      {workReportsSecondLevel && workReportsSecondLevel.length
        ? workReportsSecondLevel.map(
            ({ items: serviceLevel, agrupadoPor: providerOrUbication }) => (
              <>
                {serviceLevel.map(({ items: contractLevel, agrupadoPor: service }) => (
                  <>
                    {contractLevel.map(({ items: requestLevel, agrupadoPor: contract }, index) => (
                      <DailyWorkReportApproval
                        contract={contract}
                        fetchData={fetchData}
                        key={`${Date.now()}${index.toString()}`}
                        permissions={permissions}
                        providerOrUbication={providerOrUbication}
                        requestLevel={requestLevel}
                        selectedDate={selectedDate}
                        selectedInput={selectedInput}
                        service={service}
                        showApproveButton={showApproveButton}
                        showEditButton={showEditButton}
                        showImputationObjectButton={showImputationObjectButton}
                        showPPButton={showPPButton}
                        showRejectButton={showRejectButton}
                      />
                    ))}
                  </>
                ))}
              </>
            )
          )
        : null}
    </>
  );
};

export default HeaderTableApprovalPending;

HeaderTableApprovalPending.propTypes = {
  fetchData: PropTypes.func.isRequired,
  workReportsSecondLevel: itemsWorkReport.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedInput: PropTypes.string.isRequired,
  showApproveButton: PropTypes.bool.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  showImputationObjectButton: PropTypes.bool,
  showRejectButton: PropTypes.bool.isRequired,
  permissions: AttachedFilesPermissions,
  showPPButton: PropTypes.bool.isRequired
};

HeaderTableApprovalPending.defaultProps = {
  permissions: {
    visualize: false,
    write: false
  },
  showImputationObjectButton: true
};
